/*
 * @Author: wangyinhu wangyinhude@163.com
 * @Date: 2025-04-23 13:43:49
 * @LastEditors: wangyinhu wangyinhude@163.com
 * @LastEditTime: 2025-04-23 13:44:16
 * @FilePath: \hxt-saas-pc\src\utils\loginTime.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { userLogStart } from '../api/index.js';

// 日期格式化工具函数
const getFormattedDate = () => {
    const date = new Date()
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
}

//登录记录检查函数
const checkLoginRecord = async () => {
    const formattedDate = getFormattedDate()
    const savedLoginTime = localStorage.getItem('LoginTime')

    // 当天已记录则跳过
    if (savedLoginTime === formattedDate) return

    var deptId = window.localStorage.getItem('TopDeptId');
    var token = window.localStorage.getItem('token');

    // 必需参数检查
    if (!deptId || !token) return

    try {
        const res = await userLogStart(
            { DeviceType: 'pc' },
            {

                Authorization: token ? token : '',
                DeptId: deptId ? deptId : ""

            }
        )

        if (res.code === 0) {
            localStorage.setItem('LoginTime', formattedDate)
        }
    } catch (error) {
        console.error('登录记录请求失败:', error)
        // 可在此添加错误上报逻辑
    }
}

export default checkLoginRecord